Analytics = LP.module 'Analytics'

SearchActions =
  togglePanelCollapse: (context, payload) ->
    context.dispatch 'TOGGLE_PANEL_COLLAPSE', payload
    isIndividualPanel = typeof payload.keys == 'string'
    panel = context.getStore('PanelStore').get(payload.keys) if isIndividualPanel
    if !isIndividualPanel
      context.executeAction SearchActions.loadFacets
    else if !(panel.collapsed || panel.name == 'Power Search')
      context.executeAction SearchActions.loadFacets, { contexts: [payload.keys] }

    if LP.config.logged_in && payload.userTriggered
      context.fetcher.toggleFacetstate(payload)

  togglePanelShowMore: (context, payload) ->
    context.dispatch 'TOGGLE_PANEL_SHOW_MORE', payload
    context.executeAction SearchActions.loadFacets

  toggleFacetExpand: (context, payload) ->
    context.dispatch 'TOGGLE_FACET_EXPAND', payload

  toggleFacet: (context, payload) ->
    payload.noHistory = true
    context.dispatch 'TOGGLE_FACET', payload

    # Weird stuff with the free samples.
    # Loading the search before the GA tracking causes sometimes the sample resource not be set correctly.
    # Execute the GA tracking as a callback on success !!
    context.executeAction SearchActions.loadSearch, null, ->
      if Analytics.track and payload.facet.active
        Analytics.track "Refined Results By #{payload.facet.key.replace(/_ids?$/, '')}", label: payload.facet.title

  hideFacets: (context, payload) ->
    context.dispatch 'HIDE_FACETS', payload
    if payload.loadSearch
      context.executeAction SearchActions.loadSearch

  setParam: (context, payload) ->
    payload.noHistory = true
    context.dispatch 'SET_PARAM', payload
    context.executeAction SearchActions.loadSearch, null, ->
      if Analytics.track and
          (payload.key.indexOf('kw_') is 0 or payload.key in context.getStore('ParamStore').constructor.singleValFacets)
        Analytics.track "Refined Results By #{payload.key}", label: payload.val

  clearAllFilters: (context) ->
    context.dispatch "CLEAR_ALL", { noHistory: true }
    context.executeAction SearchActions.loadSearch

  setParams: (context, payload) ->
    payload.noHistory = true
    context.dispatch 'SET_PARAMS', payload
    context.executeAction SearchActions.loadSearch

  deleteParam: (context, payload) ->
    context.dispatch 'DELETE_PARAM', payload

  loadSearch: (context, payload, successCallback) ->
    payload = if payload? && payload.query? then payload else $.extend(true, {}, payload || {}, { query: context.getStore('ParamStore').toQueryString() })
    context.dispatch 'HIDE_RESOURCE', payload


    context.executeAction SearchActions.loadFacets, payload unless payload?.withoutFacets
    context.fetcher.getSearch(payload).done (rawSearch) =>
      # Need to know if server changed params, which usually happens because of back button click or auto-magic correct
      ai_marketing_box = document.getElementsByClassName('ai_marketing_box')
      testimonial_widget = document.getElementsByClassName('testimonial-widget')
      builder_dropzone = document.getElementsByClassName("builder-dropzone")

      if rawSearch.results == 'ai_tab'
        document.getElementById('search-results-area').classList.add("hidden")
        document.getElementById('facet-sidebar').classList.add("hidden")
        document.getElementById('iframe-area').classList.remove("hidden")
        if ai_marketing_box.length > 0
          ai_marketing_box[0].classList.remove("hidden")
        if testimonial_widget.length > 0
          testimonial_widget[0].classList.add("hidden")
        if builder_dropzone.length > 0
          builder_dropzone[0].classList.add("hidden")
      else
        if ai_marketing_box.length > 0
          ai_marketing_box[0].classList.add("hidden")
        if testimonial_widget.length > 0
          testimonial_widget[0].classList.remove("hidden")
        if builder_dropzone.length > 0
          builder_dropzone[0].classList.remove("hidden")
        document.getElementById('search-results-area').classList.remove("hidden")
        document.getElementById('iframe-area').classList.add("hidden")
        paramsDidChange = JSON.stringify(context.getStore('ParamStore').getAll()) isnt JSON.stringify(rawSearch.search_params)
        keywordsDidChange = (context.getStore('ParamStore').get('keywords') || '') isnt rawSearch.search_params['keywords']
        context.dispatch 'RECEIVE_SEARCH', rawSearch: rawSearch, paramsDidChange: paramsDidChange
        if keywordsDidChange
          payload = query: context.getStore('ParamStore').toQueryString()
          context.executeAction SearchActions.loadFacets, payload
        context.fetcher.createUserSearch params: rawSearch.search_params
      successCallback.call() if successCallback

  loadFacets: (context, payload = {}) ->
    ai_tab_init = (context.fetcher.searchXhr == null && LP.config.ai_tab)
    ai_tab_response = (context.fetcher.searchXhr && context.fetcher.searchXhr.responseJSON && context.fetcher.searchXhr.responseJSON.results == 'ai_tab')
    if ai_tab_response || ai_tab_init
      document.getElementById('facet-sidebar').classList.add("hidden")
    else
      document.getElementById('facet-sidebar').classList.remove("hidden")
      paramStore = context.getStore('ParamStore')
      query    = payload.query ? paramStore.toQueryString()
      contexts = payload.contexts ? context.getStore('PanelStore').facetContextsFilteredBy('expanded').concat(paramStore.extraFilters())
      if contexts.length
        context.fetcher.getFacets(query: query, contexts: contexts, dontAbort: payload.dontAbort).done (rawFacets) =>
          context.dispatch 'RECEIVE_FACETS', rawFacets: rawFacets

  hideResource: (context, payload) ->
    $.extend(true, payload, {type: 'resource'})
    context.dispatch 'HIDE_RESOURCE', payload

  showResource: (context, payload) ->
    $.extend(true, payload, {type: 'resource'})
    context.dispatch 'SHOW_RESOURCE', payload

  loadPanels: (context) ->
    searchTabId = context.getStore('ParamStore').get('search_tab_id')
    context.fetcher.getPanels(searchTabId).done (rawPanels) =>
      context.dispatch 'RECEIVE_PANELS', rawPanels

LP.module('Searches').SearchActions = SearchActions
